
const CallUs = () =>{

    return(
        <>
            <p>Call us bot page  test</p>
        </>
    )
}

export default CallUs